import { configureStore } from '@reduxjs/toolkit';
import { TypedUseSelectorHook, useDispatch, useSelector } from 'react-redux';
import authReducer from './authSlice';
import rolesReducer from './rolesSlice';
import usersReducer from './usersSlice';
import customFieldsReducer from './customFieldsSlice';
import employeeTagsReducer from './employeeTagsSlice';
import shiftsReducer from './shiftsSlice';
import shiftGroupsReducer from './shiftGroupsSlice';
import shiftDistributionsReducer from './shiftDistributionsSlice';
import notificationReducer from './notificationSlice';
import applicationSettingsReducer from './applicationSettingsSlice';
import employeesReducer from './employeesSlice';
import leaveTypesReducer from './leaveTypesSlice';
import leavePoliciesReducer from './leavePoliciesSlice';
import publicHolidaysReducer from './publicHolidaysSlice';
import timekeepingReducer from './timekeepingSlice';

export const store = configureStore({
  reducer: {
    auth: authReducer,
    roles: rolesReducer,
    users: usersReducer,
    customFields: customFieldsReducer,
    employeeTags: employeeTagsReducer,
    shifts: shiftsReducer,
    shiftGroups: shiftGroupsReducer,
    shiftDistributions: shiftDistributionsReducer,
    notification: notificationReducer,
    applicationSettings: applicationSettingsReducer,
    employees: employeesReducer,
    leaveTypes: leaveTypesReducer,
    leavePolicies: leavePoliciesReducer,
    publicHolidays: publicHolidaysReducer,
    timekeeping: timekeepingReducer,
  },
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;

export const useAppDispatch: () => AppDispatch = useDispatch;
export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector;
